import styled from 'styled-components'
import media from 'styled-media-query'

export type ContainerProps = {}

export const Container = styled.div<ContainerProps>`
  margin-left: 20px;
  margin-right: 20px;

  ${media.greaterThan('large')`
    width: 600px;
    margin-left: auto;
    margin-right: auto;
  `}

  ${media.greaterThan('huge')`
    width: 800px;
  `}
`
